<template>
    <div>
        <div :width="1300">
            <FGCollapsiblePanel title="操作日志">
                <!-- 表格 -->
                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    auto-resize
                    row-id="id"
                    align="left"
                    header-align="center"
                    highlight-hover-row
                    highlight-current-row
                    show-overflow="tooltip"
                    :data="tableData"
                    height="300"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="actor_pname" title="操作者姓名" width="100" align="center" v-if="!operLogProps.hiddenZZXM"> </vxe-table-column>
                    <vxe-table-column field="actor_oname" title="操作者组织名称" width="200" align="center" v-if="!operLogProps.hiddenZZXM"> </vxe-table-column>
                    <vxe-table-column field="operdesc" title="操作描述" width="200"> </vxe-table-column>
                    <vxe-table-column field="opernote" title="操作说明"> </vxe-table-column>
                    <vxe-table-column field="operdate" title="操作时间" width="150" v-if="!operLogProps.dateHidden"></vxe-table-column>
                </vxe-table>
            </FGCollapsiblePanel>
        </div>
    </div>
</template>
<script>
export default {
    name: "OperLog",
    props: ["operLogProps"],
    data() {
        return {
            tableData: []
        };
    },
    watch: {
        operLogProps: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                // if (newVal.visible) {
                //     let _this = this;
                //     if (_this.operLogProps.billid !== null && _this.operLogProps.billid !== undefined && _this.operLogProps.billid !== "") {
                //         _this.queryOperateLog();
                //     }
                // }
                if (newVal.visible && newVal.billid) {
                    this.tableData = [];
                    this.queryOperateLog();
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        queryOperateLog() {
            if (!this.operLogProps.billid) return;
            this.$FG_http
                .post(
                    "./api/activiti/queryOperateLog",
                    {
                        billid: this.operLogProps.billid
                    },
                    {
                        showError: true,
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.tableData = data.data;
                    }
                });
        }
    },
    activated() {
        this.tableData = [];
        // 仅在组件激活时重新加载数据（如果需要）
        if (this.operLogProps.visible && this.operLogProps.billid) {
            this.queryOperateLog();
        }
    },
    mounted() {}
};
</script>
<style></style>
